/*
 * @Author: shannyHuang
 * @Date: 2022-03-16 17:03:11
 * @LastEditors: brucexlliu
 * @LastEditTime: 2022-11-08 16:15:32
 * @FilePath: \wemeet-web-activity\src\model\activity.ts
 */
import { get, post } from '../lib/http';
import { GetServerSidePropsContext } from 'next';
import { HttpPrefix } from '../lib/wemeet-http-moudle';
import { Response, Activity, Page } from './type';
import useSWR from 'swr';
import { makeEventSWR } from './swr';
import { COS_STYLE_NAME } from '@utils/activity-type/add-option';
const LoadingStatusObj = {
  createEvent: false,
};
const webinarActivityPath: { [key: string]: string } = {
  delete_event: '/v2/activities/host/update-sales', // 活动下架
};
const newActivityPath: { [key: string]: string } = {
  list_coming_soon: '/v2/activities/event/coming-soon', // 即将开始列表
  list_the_past: '/v2/activities/event/the-past', // 往期活动列表
  new_list_v2: '/v2/activities/follower/news-list-v2', // 最新动态列表
  update_top_status: '/v2/activities/event/update-top-status', // 更新置顶状态
  delete_event: '/v2/activities/dashboard/event/delete-event', // 活动下架
  count_event: '/v2/activities/event/count-event', // 活动数量
};

export const returnApiUrl = (type: string, grayStatus?: boolean) => {
  if (!type) return '';
  if (grayStatus) return webinarActivityPath[type];
  return newActivityPath[type];
};
export const baseUrl = HttpPrefix.WEMEET_TAPI;
// 1.0创建活动
export interface CreateActivityParam {
  title: string;
  start_time: number;
  end_time: number;
  create_type?: number;
  charge_type?: number;
  is_public?: number;
  schedule_type?: number;
}
interface CreateResponse extends Response {
  data?: { event_id?: string };
}
export const CreateActivity = (params?: CreateActivityParam, ctx?: GetServerSidePropsContext) => {
  // 给每次请求加Loading
  if (LoadingStatusObj.createEvent) return;
  LoadingStatusObj.createEvent = true;
  return post<CreateResponse>(
    baseUrl,
    '/v2/activities/dashboard/event/create-event',
    params || {},
    ctx,
  ).then((res) => {
    console.log('CreateResponse', res);
    LoadingStatusObj.createEvent = false;
    return respIntercept(res);
  });
};
// 获取活动详情
// /v2/activities/dashboard/event/info
/** 活动信息 */
export interface ActivityInfo {
  /** 活动ID */
  event_id: string;
  /** 主办方ID */
  host_id: number;
  /** 主办方名 */
  host_name: string;
  /** 活动主题 */
  title: string;
  /** 活动开始时间 */
  start_time: number;
  /** 活动结束时间 */
  end_time: number;
  /** 时区 */
  time_zone: string;
  /** 活动行业分类名 */
  industry_name?: string;
  /** 活动行业分类编码 */
  industry_code?: string;
  /** 活动标签数组 */
  labels: string[];
  // venues: {
  //   /** 会场类型，如：大型会议为stage */
  //   type: string;
  //   /** 会场数量 */
  //   count: string;
  // }[];
  /** 活动状态，未发布0、待开始1、进行中2、已结束3 */
  status: number;
  /** 封面图url */
  cover_url: string;
  /** 收费类型，1免费，2收费 3免费+收费 */
  charge_type: number;
  /** 日程类型 0 单场 1 多场*/
  schedule_type: number;
  /** 模板类型名 */
  template: string;
  /** 活动类型，-1为旧版webinar，0位新版活动 */
  event_type: number;
  /** 是否公开，0为不公开，1为公开 */
  is_public: number;
  /** 活动地址 */
  address: string;
  ticket_info?: {
    /** 门票最小价格。单位：分 */
    min_fee: number;
    /** 门票最大价格。单位：分 */
    max_fee: number;
    /** 门票数量 */
    amount_num: string;
    /** 库存数量 */
    stock_num: string;
    /** 自定义门票列表 */
    custom_ticket_list: {
      /** 门票名称 */
      name: string;
      /** 门票数量 */
      amount_num: number;
      /** 门票价格。单位：分 */
      fee: number;
    }[];
    /** 保留门票 */
    reserved_ticket: {
      /** 嘉宾门票数量 */
      guest_num: number;
      /** 主持人门票数量 */
      compere_num: number;
      /** 特邀观众门票数量 */
      audience_num: number;
    };
  };
}

/** 活动详情页面菜单 */
export const useActivityMenus = makeEventSWR<{ event_id: string }, Record<string, string>>(
  '/v2/activities/dashboard/event/sidebar',
  'post',
  (list) =>
    list.menu_list.reduce((prev: any, cur: any) => {
      if (!cur.is_show) return prev;
      return { ...prev, [cur.key]: cur.name };
    }, {}),
);

// // 获取活动数量
// interface CountRequestParam {
//   query_view?: number;
//   host_id?: string | number;
//   mock?: boolean;
// }
// interface ListcountRes extends Response {
//   data: CountData;
// }
export interface CountData {
  coming_soon_count: number;
  the_past_count: number;
  total_count: number;
  in_draft_count?: number;
}

// export const ActivitiesCount = (params?: CountRequestParam, ctx?: GetServerSidePropsContext) => {
//   const param = { ...params };
//   const baseUrl = formatBaseUrl(params?.mock);
//   const url = returnApiUrl('count_event');
//   delete param?.mock;
//   return get<ListcountRes>(baseUrl, url, params || {}, ctx).then(respIntercept);
// };

// 查询即将开始的活动
interface ComingListRequestParam {
  query_view?: number;
  host_id?: string;
  page?: number;
  page_size?: number;
}
interface ListRes extends Response {
  data: ListData;
}
interface ListData {
  activities: Activity;
  page: Page;
}
export const getSoonActivityList = (
  params?: ComingListRequestParam,
  ctx?: GetServerSidePropsContext,
) => {
  const param = { cover_image_type: COS_STYLE_NAME.EVENT[1], ...params };
  const url = returnApiUrl('list_coming_soon');
  return get<ListRes>(baseUrl, url, param || {}, ctx).then(respIntercept);
};
// 查询往期的活动
export const getThePastActivityList = (
  params?: ComingListRequestParam,
  ctx?: GetServerSidePropsContext,
) => {
  const param = { cover_image_type: COS_STYLE_NAME.EVENT[1], ...params };
  const url = returnApiUrl('list_the_past');
  return get<ListRes>(baseUrl, url, param || {}, ctx).then(respIntercept);
};
// 查询草稿箱列表
interface DraftListParam extends NewsListRequestParam {
  host_id?: string;
}
export const getDraftList = (params?: DraftListParam, ctx?: GetServerSidePropsContext) => {
  const param = { cover_image_type: COS_STYLE_NAME.EVENT[1], ...params };

  return get<ListRes>(baseUrl, '/v2/activities/event/list-draft', param || {}, ctx).then(
    respIntercept,
  );
};
// 更新活动下架
interface SaleRequestParam {
  meeting_id?: string;
  is_on_sale?: number;
}

export const UpDateActivitySale = (params?: SaleRequestParam, ctx?: GetServerSidePropsContext) => {
  const url = returnApiUrl('delete_event', true);
  return post<Response>(baseUrl, url, params || {}, ctx).then(respIntercept);
};

// 更新活动置顶
export interface TopRequestParam {
  meeting_id?: string; // webinar活动id
  event_id?: string; // 新版活动id
  is_on_top?: number;
}

export const UpdateActivityTop = (params?: TopRequestParam, ctx?: GetServerSidePropsContext) => {
  const url = returnApiUrl('update_top_status');
  return post<Response>(baseUrl, url, params || {}, ctx).then(respIntercept);
};
// 删除1.0 活动
interface DeleteParam {
  event_id?: string;
}
export const DeleteActivityRomte = (params?: DeleteParam, ctx?: GetServerSidePropsContext) =>
  post<Response>(baseUrl, '/v2/activities/dashboard/event/delete-event', params || {}, ctx).then(
    respIntercept,
  );

// 获取最新动态列表
interface NewsListRequestParam {
  page?: number;
  page_size?: number;
}

export const getNewsList = (params?: NewsListRequestParam, ctx?: GetServerSidePropsContext) => {
  const param = { cover_image_type: COS_STYLE_NAME.EVENT[1], ...params };
  const url = returnApiUrl('new_list_v2');
  return get<ListRes>(baseUrl, url, param || {}, ctx).then(respIntercept);
};
export interface ImageRequestParams {
  meeting_id?: string;
  image_type?: number; // 0原图，1小图，2中图，3大图
}
interface ImageRes extends Response {
  data?: { cover_url?: string };
}
/** 获取图片链接 */
export const getImageUrl = async (params?: ImageRequestParams, ctx?: GetServerSidePropsContext) => {
  const param = { ...params };
  try {
    const response = await get<ImageRes>(
      baseUrl,
      '/v2/activities/public/cover-url',
      param || {},
      ctx,
    );
    return response;
  } catch (e) {
    console.error('request error', e);
  }
};

interface IndustriesRes extends Response {
  data?: { industries?: object[] };
}

// 获取活动的行业列表
export const GetIndustriesList = (ctx?: GetServerSidePropsContext) =>
  useSWR(
    {
      url: '/v2/activities/public/dashboard/event/industries',
      params: {},
      ctx,
    },
    async ({ url, params, ctx }) => {
      const res = await get<IndustriesRes>(baseUrl, url, params, ctx);
      return res || {};
    },
    {
      onSuccess: (data) => {
        console.log(data);
      },
      revalidateOnFocus: false,
    },
  );

interface EventRequestParam {
  event_id?: string;
  title?: string;
  start_time?: number;
  end_time?: number;
  time_zone?: string;
  industry_code?: string;
  labels?: string[];
  venues?: string[];
  ticket_type?: string | number;
  address?: string;
  is_public?: string | number;
  venue_type?: number[];
  /**
   * 活动时间和日程时间存在冲突的日程列表
   */
  schedule_list?: {
    /**
     * 日程id
     */
    schedule_id?: string;
    /**
     * 日程开始时间
     */
    begin_time?: number;
    /**
     * 日程结束时间
     */
    end_time?: number;
    /**
     * 活动时间和日程时间存在冲突时的冲突类型
     * 1:日程时间跟活动时间冲突
     * 2:二次发布时有进行中或已结束的日程
     */
    error_type?: number;
  }[];
}

// 更新活动基础信息
export const UpDateActivityEvent = async (
  params?: EventRequestParam,
  ctx?: GetServerSidePropsContext,
) => {
  try {
    const response = await post<Response>(
      baseUrl,
      '/v2/activities/dashboard/event/update-event',
      params || {},
      ctx,
    );
    return response;
  } catch (e) {
    console.error('request error', e);
  }
  return null;
};

// 获取活动时间和日程时间存在冲突的日程列表
export const getExceptionScheduleList = (
  event_id: string,
  start_time: number,
  end_time: number,
) => {
  const path = '/v2/activities/dashboard/event/check-event-time-change';
  return post<Response>(
    HttpPrefix.WEMEET_TAPI,
    // HttpPrefix.YAPI_API,
    path,
    {
      event_id,
      start_time,
      end_time,
    },
  ).then((res) => {
    if (res.code !== 0) return Promise.reject(res.msg || res.err_detail);
    return res.data;
  });
};

// 活动发布
export interface PublishRequestParams {
  event_id: string;
}
export const publishActivity = async (
  params?: PublishRequestParams,
  ctx?: GetServerSidePropsContext,
) =>
  post<Response>(baseUrl, '/v2/activities/dashboard/event/publish-event', params || {}, ctx).then(
    respIntercept,
  );
// 撤销发布接口
export const unPublishActivityRemote = async (
  params?: PublishRequestParams,
  ctx?: GetServerSidePropsContext,
) =>
  await post<Response>(
    baseUrl,
    '/v2/activities/dashboard/event/unpublish-event',
    params || {},
    ctx,
  ).then(respIntercept);

const respIntercept = (resp: any) => {
  if (resp.code !== 0) return Promise.reject(resp.msg || resp.err_detail);
  return resp.data;
};
